/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */

const checkRole = (currentUser: API.CurrentUser | undefined) => {
  return (roles: string[]): boolean => {
    if (!currentUser || !currentUser.permissions) {
      return false;
    }

    const per = currentUser.permissions;
    if (per.includes('all')) {
      return true;
    }
    for (const role of roles) {
      if (per.includes(role)) {
        return true;
      }
    }
    return false;
  };
};

export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
): ACCESS.Check {
  const { currentUser } = initialState ?? {};
  const c = checkRole(currentUser);
  const isAdmin = currentUser?.isSuperUser || false;

  return {
    isAdmin,
    listRole: c(['GET_ROLES']),
    createRole: c(['CREATE_ROLES']),
    updateRole: c(['UPDATE_ROLES']),
    deleteRole: c(['DELETE_ROLES']),
    updateRolePermissions: c(['UPDATE_ROLE_PERMISSIONS']),
    listUser: c(['GET_USER']),
    menuUser: c(['GET_USER', 'GET_ROLES']),
    createUser: c(['CREATE_USER']),
    updateUser: c(['UPDATE_USER']),
    deleteUser: c(['DELETE_USER']),
    banUser: c(['BANED_USER']),

    listMasterPlan: c(['GET_MASTER_PLANS']),
    createMasterPlan: c(['CREATE_UPDATE_MASTER_PLAN']),
    deleteMasterPlan: c(['DELETE_MASTER_PLANS']),
    hideMasterPlan: c(['HIDE_MASTER_PLANS']),
    showHideActiveMasterPlan: c(['SHOW_HIDE_ACTIVE_MASTER_PLANS']),

    listAllPackage: c(['GET_ALL_PACKAGES']),
    listPackage: c(['GET_PACKAGES']),
    updatePackage: c(['UPDATE_PACKAGES']),
    createPackage: c(['CREATE_PACKAGES']),
    deletePackage: c(['DELETE_PACKAGES']),
    downloadPackage: c(['DOWNLOAD_PACKAGES']),
    importPackage: c(['IMPORT_PACKAGES']),
    createDataPackage: c(['CREATE_DATA_PACKAGE']),
    userCreateDataPackage: c(['USER_CREATE_DATA_PACKAGE']),

    createUpdatePackage: c(['CREATE_UPDATE_PACKAGES']), //check lại quyền

    listProductSim: c(['GET_PRODUCT_SIMS']),
    createUpdateProductSim: c(['CREATE_UPDATE_PRODUCT_SIM']),
    updateSimPrepaid: c(['UPDATE_SIM_PREPAID']),
    updateSimPostpaid: c(['UPDATE_SIM_POSTPAID']),
    detailSimPrepaid: c(['DETAIL_SIM_PREPAID']),
    detailSimPostpaid: c(['DETAIL_SIM_POSTPAID']),
    createNewFileProductSimPrepaid: c(['CREATE_NEW_FILE_PRODUCT_SIM_PREPAID']),
    createNewFileProductSimPostpaid: c(['CREATE_NEW_FILE_PRODUCT_SIM_POSTPAID']),
    getAllInfoSim: c(['GET_ALL_SIMS']),
    deleteProductSim: c(['DELETE_PRODUCT_SIM']),
    exportAgentSim: c(['EXPORT_AGENT_SIM']),
    getRetailWareHouse: c(['GET_WAREHOUSE_RETAIL']),
    getRetailWareHouseWifi: c(['GET_WAREHOUSE_RETAIL_WIFI']),
    cutSim: c(['CUT_SIM']),
    openSim: c(['OPEN_SIM']),
    renewSim: c(['RENEW_SIM']),
    cancelSim: c(['CANCEL_SIM']),
    expiredSim: c(['EXPIRED_SIM']),
    changeError: c(['CHANGE_ERROR']),
    downloadFileSimPostpaid: c(['DOWLOAD_SIM_POSTPAID']),
    //Prepaid SIM
    showHideContractAgent: c(['SHOW_HIDE_CONTRACT_AGENT']),
    showHideSupply: c(['SHOW_HIDE_SUPPLY']),
    showHideCostInLabel: c(['SHOW_HIDE_COST_IN_LABEL']),
    showHidePricingInLabel: c(['SHOW_HIDE_PRICING_IN_LABEL']),
    showHideActiveCodePostpaid: c(['SHOW_HIDE_ACTIVE_CODE_POSTPAID']),
    showHideActiveCodePrepaid: c(['SHOW_HIDE_ACTIVE_CODE_PREPAID']),
    showHideCopyImageQrCodePostpaid: c(['SHOW_HIDE_COPY_IMAGE_QR_CODE_POSTPAID']),
    showHideCopyImageQrCodePrepaid: c(['SHOW_HIDE_COPY_IMAGE_QR_CODE_PREPAID']),
    deletePrepaidSim: c(['DELETE_SIM_PREPARE']),
    downloadFilePrepaidSim: c(['DOWLOAD_SIM_PREPAID']),
    cutPrepaidSim: c(['CUT_SIM_PREPARE']),
    renewPrepaidSim: c(['RENEW_SIM_PREPARE']),
    openPrepaidSim: c(['OPEN_SIM_PREPARE']),
    cancelPrepaidSim: c(['CANCEL_SIM_PREPARE']),
    changeErrorPrepaidSim: c(['CHANGE_ERROR_SIM_PREPARE']),
    exportAgentPrepaidSim: c(['EXPORT_AGENT_SIM_PREPARE']),
    listProductSimPrepaid: c(['GET_PRODUCT_SIMS_PREPARE']),
    restockPostpaidSim: c(['RESTOCK_SIM_POSTPAID']),
    changeErrorPostpaidSim: c(['CHANGE_ERROR_SIM_POSTPAID']),
    restockPrepaidSim: c(['RESTOCK_SIM_PREPAID']),
    //Xuất sim lẻ cho Đại lý
    exportAgentSimPage: c(['EXPORT_AGENT_SIM_PAGE']),
    receiptPage: c(['GET_PAYMENT', 'PAYMENT_STATIC', 'VIEW_LIST_PLAN', 'VIEW_LIST_SUBSCRIPTION']),

    cmd: c(['CMD']),
    canGetAllCmd: c(['CAN_GET_ALL_CMD']),

    networkProviderNotProcess: c(['NETWORK_PROVIDER_NOT_PROCESS']),
    networkProviderProcessing: c(['NETWORK_PROVIDER_PROCESSSING']),
    handleCmdComplete: c(['CMD_COMPLETE']),
    handleCmdProcessing: c(['CMD_HANDLE_PROCESSING']),
    handleCmdCancel: c(['CMD_DELETE']),
    downloadFileCmd: c(['CMD_DOWNLOAD']),
    cmdAccount: c(['CMD_ACCOUNT']),
    userCmd: c(['USER_CMD']),
    timeCmd: c(['TIME_CMD']),
    //Danh sách đổi Sim
    changeErrorScreen: c(['CHANGE_ERROR_SCREEN']),
    canGetAllChangeErrorSim: c(['CAN_GET_ALL_CHANGE_ERROR_SIM']),
    changeErrorSimCmd: c(['CHANGE_ERROR_SIM_CMD']),
    updateChangeErrorSim: c(['UPDATE_CHANGE_ERROR_SIM']),
    managerDataSim: c(['MANAGER_DATA_SIM']),
    createNewFileManagerDataSim: c(['CREATE_NEW_FILE_MANAGER_DATA_SIM']),
    supplierManagerDataSim: c(['SUPPLIER_MANAGER_DATA_SIM']),
    downloadFileManagerDataSim: c(['DOWNLOAD_FILE_MANAGER_DATA_SIM']),
    createNewFileChangeSim: c(['CREATE_NEW_FILE_CHANGE_SIM']),
    downloadFileChangeSim: c(['DOWNLOAD_FILE_CHANGE_SIM']),
    deleteChangeSim: c(['DELETE_CHANGE_SIM']),
    //Quản lý hợp đồng Sim
    managerContractSim: c(['MANAGER_CONTRACT_SIM']),
    canGetAllContractSim: c(['CAN_GET_ALL_CONTRACT_SIM']),
    downloadFileContractSim: c(['DOWNLOAD_FILE_CONTRACT_SIM']),

    //Quản lý hợp đồng MVNO
    managerContractMvno: c(['MANAGER_CONTRACT_MVNO']),
    downloadFileContractMvno: c(['DOWNLOAD_FILE_CONTRACT_MVNO']),
    exportWareHouseRetailSim: c(['EXPORT_WAREHOUSE_RETAIL_SIM']),
    exportWareHouseRetailWifi: c(['EXPORT_WAREHOUSE_RETAIL_WIFI']),

    listProductMVNO: c(['GET_PRODUCT_MVNO']),
    getAllInfoMVNO: c(['GET_ALL_MVNOS']),
    exportMVNO: c(['EXPORT_MVNO']),
    exportAgentMVNO: c(['EXPORT_AGENT_MVNO']),
    restockMVNO: c(['RESTOCK_MVNO']),
    createNewFileMVNO: c(['CREATE_NEW_FILE_MVNO']),
    downloadFileMVNO: c(['DOWNLOAD_FILE_MVNO']),
    supplierMVNO: c(['SUPPLIER_MVNO']),
    costInLabelMVNO: c(['COST_IN_LABEL_MVNO']),
    costOutLabelMVNO: c(['COST_OUT_LABEL_MVNO']),
    pricingInLabelMVNO: c(['PRICING_IN_LABEL_MVNO']),
    pricingInLabelKakehodaicontractMvno: c(['PRICING_IN_LABEL_KAKEHODAI_MVNO']),
    pricingOutLabelMVNO: c(['PRICING_OUT_LABEL_MVNO']),
    pricingOutLabelKakehodaicontractMvno: c(['PRICING_OUT_LABEL_KAKEHODAI_MVNO']),
    updateMvno: c(['UPDATE_MVNO']),
    detailMvno: c(['DETAIL_MVNO']),
    exportRetailMVNO: c(['GET_WAREHOUSE_RETAIL_MVNO']),
    createUpdateProductMVNO: c(['CREATE_UPDATE_PRODUCT_MVNO']),
    activeMvno: c(['ACTIVE_MVNO']),
    callAgainActiveMVNO: c(['CALL_AGAIN_ACTIVE_MVNO']),
    downloadActiveMVNO: c(['TRANSFER_MVNO_DOWNLOAD']),
    accountTransferMVNO: c(['ACCOUNT_TRANSFER_MVNO']),
    timeTransferMVNO: c(['TIME_TRANSFER_MVNO']),
    deleteActiveMVNO: c(['TRANSFER_MVNO_DELETE']),
    transferMvno: c(['TRANSFER_MVNO']),
    transferMvnoCmd: c(['TRANSFER_MVNO_CMD']),
    transferMvnoList: c(['TRANSFER_MVNO_LIST', 'TRANSFER_MVNO_CMD']),
    canGetAllTransferMVNO: c(['CAN_GET_ALL_TRANSFER_MVNO']),
    cmdMVNO: c(['CMD_MVNO']),
    downloadCmdMVNO: c(['DOWNLOAD_CMD_MVNO']),
    completedCmdMVNO: c(['COMPLETED_CMD_MVNO']),
    deleteCmdMVNO: c(['DELETE_CMD_MVNO']),
    accountCmdMVNO: c(['ACCOUNT_CMD_MVNO']),
    timeCmdMVNO: c(['TIME_CMD_MVNO']),
    handleCmdMVNO: c(['CMD_HANDLE_MVNO']),
    canGetAllCmdHandleMVNO: c(['CAN_GET_ALL_CMD_HANDLE_MVNO']),
    renewMVNO: c(['RENEW_MVNO']),
    cancelMVNO: c(['CANCEL_MVNO']),
    deleteMVNO: c(['DELETE_MVNO']),
    costsIncurred: c(['COSTS_INCURRED']),
    createUpdateCostsIncurred: c(['CREATE_UPDATE_COSTS_INCURRED']),
    downloadCostsIncurred: c(['DOWNLOAD_COSTS_INCURRED']),
    deleteCostsIncurred: c(['DELETE_COSTS_INCURRED']),
    userCostsIncurred: c(['USER_COSTS_INCURRED']),
    getAllCppsSms: c(['GET_ALL_CPPS_SMS']),
    canGetAllCppsSms: c(['CAN_GET_ALL_CPPS_SMS']),
    createUpdateCppsSms: c(['CREATE_UPDATE_CPPS_SMS']),
    costsIncurredThreshold: c(['COSTS_INCURRED_THRESHOLD']),
    createUpdateCostsIncurredThreshold: c(['CREATE_UPDATE_COSTS_INCURRED_THRESHOLD']),
    deleteCostsIncurredThreshold: c(['DELETE_COSTS_INCURRED_THRESHOLD']),
    openCostsIncurredThreshold: c(['OPEN_COSTS_INCURRED_THRESHOLD']),
    downloadCostsIncurredThreshold: c(['DOWNLOAD_COSTS_INCURRED_THRESHOLD']),
    uploadCostsIncurredThreshold: c(['UPLOAD_COSTS_INCURRED_THRESHOLD']),
    canGetAllCostsIncurredThreshold: c(['CAN_GET_ALL_COSTS_INCURRED_THRESHOLD']),
    cutSimMvno: c(['CUT_SIM_MVNO']),
    openSimMvno: c(['OPEN_SIM_MVNO']),
    buyUsageMvno: c(['BUY_USAGE_MVNO']),
    buyUsageMvnoList: c(['BUY_USAGE_MVNO_LIST']),
    canGetAllBuyUsageMvno: c(['CAN_GET_ALL_BUY_USAGE_MVNO']),
    buyUsageMvnoCmd: c(['BUY_USAGE_MVNO_CMD']),
    downloadBuyUsageMvno: c(['DOWNLOAD_BUY_USAGE_MVNO']),
    deleteBuyUsageMvno: c(['DELETE_BUY_USAGE_MVNO']),
    callApiMvno: c(['CALL_API_MVNO']),
    activeEsim: c(['ACTIVE_MVNO_ESIM']),
    reissueEsim: c(['REISSUE_ESIM']),
    reissueProfile: c(['REISSUE_PROFILE']),
    managerDataMvno: c(['MANAGER_DATA_MVNO']),
    createNewFileManagerDataMvno: c(['CREATE_NEW_FILE_MANAGER_DATA_MVNO']),
    downloadFileManagerDataMvno: c(['DOWNLOAD_FILE_MANAGER_DATA_MVNO']),
    supplierManagerDataMvno: c(['SUPPLIER_MANAGER_DATA_MVNO']),

    listProductWifi: c(['GET_PRODUCT_WIFI']),

    buyUsageDataWifi: c(['BUY_USAGE_DATA_WIFI']),
    upgradeOrDowngradePackWifi: c(['UPGRADE_OR_DOWNGRADE_PACK_WIFI']),
    changePackgeWifi: c(['CHANGE_PACKGE_WIFI']),
    exportWifiToAgent: c(['EXPORT_WIFI_TO_AGENT']),
    cutWifi: c(['CUT_WIFI']),
    openWifi: c(['OPEN_WIFI']),
    renewWifi: c(['RENEW_WIFI']),
    restockWifi: c(['RESTOCK_WIFI']),
    downloadWifi: c(['DOWNLOAD_WIFI']),
    createNewFileWifi: c(['CREATE_NEW_FILE_WIFI']),

    getAllInfoWifi: c(['GET_ALL_WIFI']),
    createUpdateProductWifi: c(['CREATE_UPDATE_PRODUCT_WIFI']),
    exportAgentWifi: c(['EXPORT_AGENT_WIFI']),
    exportRetailWifi: c(['GET_WAREHOUSE_RETAIL_WIFI']),
    transferWifi: c(['TRANSFER_WIFI', 'CHANGE_PACKGE_WIFI']),
    transferWifiCmd: c(['TRANSFER_WIFI_CMD']),
    transferWifiList: c(['TRANSFER_WIFI_LIST']),
    getAllTransferWifi: c(['TRANSFER_WIFI_GET_ALL']),
    downloadTransferWifi: c(['TRANSFER_WIFI_DOWNLOAD']),
    accountTransferWifi: c(['ACCOUNT_TRANSFER_WIFI']),
    userTransferWifi: c(['USER_TRANSFER_WIFI']),
    timeTransferWifi: c(['TIME_TRANSFER_WIFI']),
    deleteTransferWifi: c(['TRANSFER_WIFI_DELETE']),
    contractWifi: c(['CONTRACT_WIFI']),
    contractWifiGetAll: c(['CONTRACT_WIFI_GET_ALL']),
    contractWifiDownload: c(['CONTRACT_WIFI_DOWNLOAD']),
    costOutContractWifi: c(['COST_OUT_CONTRACT_WIFI']),

    isTcn: c(['IS_TCN']),
    buyUsage: c(['BUY_USAGE_WIFI']),
    buyUsageList: c(['BUY_USAGE_WIFI_LIST']),
    canGetAllBuyUsageWifi: c(['CAN_GET_ALL_BUY_USAGE_WIFI']),
    accountBuyUsageWifi: c(['ACCOUNT_BUY_USAGE_WIFI']),
    userBuyUsageWifi: c(['USER_BUY_USAGE_WIFI']),
    timeBuyUsageWifi: c(['TIME_BUY_USAGE_WIFI']),

    buyUsageCmd: c(['BUY_USAGE_WIFI_CMD']),
    changeErrorWifi: c(['CHANGE_ERROR_WIFI']),
    changeErrorWifiGet: c(['CHANGE_ERROR_WIFI_GET']),
    changeErrorWifiCmd: c(['CHANGE_ERROR_WIFI_CMD']),
    downloadChangeErrorWifi: c(['DOWNLOAD_CHANGE_ERROR_WIFI']),
    createChangeErrorWifi: c(['CREATE_CHANGE_ERROR_WIFI']),
    masterDataChangeErrorWifi: c(['MASTER_DATA_CHANGE_ERROR_WIFI']),
    accountChangeErrorWifi: c(['ACCOUNT_CHANGE_ERROR_WIFI']),
    userChangeErrorWifi: c(['USER_CHANGE_ERROR_WIFI']),
    timeChangeErrorWifi: c(['TIME_CHANGE_ERROR_WIFI']),
    changeErrorWifiCancel: c(['CHANGE_ERROR_WIFI_CANCEL']),
    cancelWifi: c(['CANCEL_WIFI']),
    cancelWifiCmd: c(['CANCEL_WIFI_CMD']),
    cancelCancelWifi: c(['CANCEL_CANCEL_WIFI']),
    getAllCancelWifi: c(['GET_ALL_CANCEL_WIFI']),
    canGetAllCancelWifi: c(['CAN_GET_ALL_CANCEL_WIFI']),
    downloadCancelWifi: c(['DOWNLOAD_CANCEL_WIFI']),
    deleteCancelWifi: c(['DELETE_CANCEL_WIFI']),
    accountCancelWifi: c(['ACCOUNT_CANCEL_WIFI']),
    userCancelWifi: c(['USER_CANCEL_WIFI']),
    timeCancelWifi: c(['TIME_CANCEL_WIFI']),
    listPriceUsageWifi: c(['GET_PRICE_USAGE_WIFIS']),
    updatePriceUsageWifi: c(['UPDATE_PRICE_USAGE_WIFIS']),
    createPriceUsageWifi: c(['CREATE_PRICE_USAGE_WIFIS']),
    deletePriceUsageWifi: c(['DELETE_PRICE_USAGE_WIFIS']),

    listMvnoCost: c(['GET_MVNO_COSTS']),
    createMvnoCost: c(['CREATE_MVNO_COSTS']),
    updateMvnoCost: c(['UPDATE_MVNO_COSTS']),
    updateMvnoCostCommonFees: c(['UPDATE_MVNO_COST_COMMON_FEES']),
    deleteMvnoCost: c(['DELETE_MVNO_COSTS']),
    importMvnoCost: c(['IMPORT_MVNO_COSTS']),
    listMvnoActiveRouting: c(['GET_MVNO_ACTIVE_ROUTINGS']),
    createMvnoActiveRouting: c(['CREATE_MVNO_ACTIVE_ROUTINGS']),
    updateMvnoActiveRouting: c(['UPDATE_MVNO_ACTIVE_ROUTINGS']),
    updateMvnoRoutingContractTerm: c(['UPDATE_MVNO_ROUTING_CONTRACT_TERM']),

    listUpgradePackWifi: c(['GET_UPGRADE_PACK_WIFI']),
    canGetAllUpgradePackWifi: c(['CAN_GET_ALL_UPGRADE_PACK_WIFI']),
    createUpgradePackWifi: c(['CREATE_UPDATE_UPGRADE_PACK_WIFI']),
    cmdUpgradePackWifi: c(['CMD_UPGRADE_PACK_WIFI']),
    downloadUpgradePackWifi: c(['DOWNLOAD_UPGRADE_PACK_WIFI']),
    deleteUpgradePackWifi: c(['DELETE_UPGRADE_PACK_WIFI']),

    accountUpgradePackWifi: c(['ACCOUNT_UPGRADE_PACK_WIFI']),
    userUpgradePackWifi: c(['USER_UPGRADE_PACK_WIFI']),
    timeUpgradePackWifi: c(['TIME_UPGRADE_PACK_WIFI']),

    buyUsageWifiDownload: c(['BUY_USAGE_WIFI_DOWNLOAD']),
    buyUsageWifiDelete: c(['BUY_USAGE_WIFI_DELETE']),
    paymentStatic: c(['PAYMENT_STATIC']),
    paymentStaticAll: c(['PAYMENT_STATIC_ALL']),
    createReceipt: c(['CREATE_RECEIPT']),
    sendReceipt: c(['SEND_RECEIPT']),
    deleteReceipt: c(['DELETE_RECEIPT']),

    checkData: c(['CHECK_DATA_WIFI']),
    canGetAllCheckDataWifi: c(['CAN_GET_ALL_CHECK_DATA_WIFI']),
    downloadCheckDataWifi: c(['DOWNLOAD_CHECK_DATA_WIFI']),
    masterDataCheckWifi: c(['MASTER_DATA_CHECK_WIFI']),
    stateWifi: c(['CHECK_STATE_WIFI']),
    canGetAllCheckStateWifi: c(['CAN_GET_ALL_CHECK_STATE_WIFI']),
    downloadStateWifi: c(['DOWNLOAD_CHECK_STATE_WIFI']),

    listSmartpitAll: c(['GET_SMARTPIT_ALL']),
    listSmartpit: c(['GET_SMARTPIT']),
    createSmartpit: c(['CREATE_UPDATE_SMARTPIT']),
    deleteSmartpit: c(['DELETE_SMARTPIT']),
    downloadSmartpit: c(['DOWNLOAD_SMARTPIT']),

    listSupplier: c(['GET_SUPPLIERS']),
    createSupplier: c(['CREATE_SUPPLIER']),
    updateSupplier: c(['UPDATE_SUPPLIER']),
    deleteSupplier: c(['DELETE_SUPPLIER']),

    changeDevice: c(['CHANGE_DEVICE']),
    changeDeviceGet: c(['CHANGE_DEVICE_GET']),
    changeDeviceCmd: c(['CHANGE_DEVICE_CMD']),
    // CRM-160 Dashboard kinh doanh
    dashboardBusiness: c(['DASHBOARD_BUSINESS', 'DASHBOARD_BUSINESS_ALL']),
    dashboardBusinessAll: c(['DASHBOARD_BUSINESS_ALL']),

    monthlyProduct: c(['GET_MONTHLY_PRODUCT']),

    updateMonthlyProduct: c(['UPDATE_MONTHLY_PRODUCT']),
    detailMonthlyProduct: c(['DETAIL_MONTHLY_PRODUCT']),
    updateMonthlySubscribeProduct: c(['UPDATE_MONTHLY_SUBCRIBE_PRODUCT']),
    detailMonthlySubscribeProduct: c(['DETAIL_MONTHLY_SUBCRIBE_PRODUCT']),

    //Sim trả trước, Wifi du lịch
    exportProductTravel: c(['EXPORT_PRODUCT_TRAVEL']),
    importProductTravel: c(['IMPORT_PRODUCT_TRAVEL']),
    createNewFileProductTravel: c(['CREATE_NEW_FILE_PRODUCT_TRAVEL']),
    downloadFileProductTravel: c(['DOWNLOAD_FILE_PRODUCT_TRAVEL']),

    buyUsageProductTravel: c(['BUY_USAGE_PRODUCT_TRAVEL']),
    transferProductTravel: c(['TRANSFER_PRODUCT_TRAVEL']),
    cutProductTravel: c(['CUT_PRODUCT_TRAVEL']),
    openProductTravel: c(['OPEN_PRODUCT_TRAVEL']),
    renewProductTravel: c(['RENEW_PRODUCT_TRAVEL']),
    cancelProductTravel: c(['CANCEL_PRODUCT_TRAVEL']),
    updateProductTravel: c(['UPDATE_PRODUCT_TRAVEL']),
    //Xuất sim trả trước - wifi du lịch
    exportSimPrepaidTravelPage: c(['EXPORT_SIM_PREPAID_TRAVEL_PAGE']),

    cancelRetailSim: c(['CANCEL_RETAIL_SIM']),
    cancelRetailSimList: c(['CANCEL_RETAIL_SIM_LIST']),
    cancelRetailSimCmd: c(['CANCEL_RETAIL_SIM_CMD']),
    cancelRetailWifi: c(['CANCEL_RETAIL_WIFI']),
    cancelUpdatePaymentSim: c(['UPDATE_STATUS_RETAIL_SIM']),
    cancelUpdatePaymentWifi: c(['UPDATE_STATUS_RETAIL_WIFI']),
    monthlyPaymentConfirmation: c(['MONTHLY_PAYMENT_CONFIRMATION']),
    monthlyExportProduct: c(['MONTHLY_EXPORT_PRODUCT']),
    monthlyExportProductPage: c(['EXPORT_MONTHLY_PRODUCT_PAGE']),
    deleteMonthly: c(['DELETE_MONTHLY']),
    downloadMonthly: c(['DOWNLOAD_MONTHLY']),
    createNewFileMonthly: c(['CREATE_NEW_FILE_MONTHLY']),
    monthlyReImportProduct: c(['MONTHLY_RE_IMPORT_PRODUCT']),
    monthlyCut: c(['MONTHLY_CUT']),
    monthlyOpen: c(['MONTHLY_OPEN']),
    monthlyCancel: c(['MONTHLY_CANCEL']),
    monthlyRenew: c(['MONTHLY_RENEW']),
    monthlyHandleCmd: c(['MONTHLY_HANDLE_CMD']),
    monthlyCmd: c(['MONTHLY_CMD']),
    travelWifi: c(['GET_TRAVEL_WIFI']),
    canGetAllTravelWifi: c(['CAN_GET_ALL_TRAVEL_WIFI']),
    monthlyChangePackage: c(['MONTHLY_CHANGE_PACKAGE']),
    monthlyBuyUsage: c(['MONTHLY_BUY_USAGE']),
    getCustomerRequests: c(['GET_CUSTOMER_REQUESTS']),
    handlerCustomerRequests: c(['HANDLER_CUSTOMER_REQUESTS']),
    deleteCustomerRequests: c(['DELETE_CUSTOMER_REQUESTS']),
    downloadCustomerRequests: c(['DOWNLOAD_CUSTOMER_REQUESTS']),
    getPoint: c(['GET_POINT']),
    giftPoint: c(['GIFT_POINT']),
    downloadPoint: c(['DOWNLOAD_POINT']),
    createNewFilePoint: c(['CREATE_NEW_FILE_POINT']),
    deletePoint: c(['DELETE_POINT']),

    cmdRetailCustomerList: c(['CMD_RETAIL_CUSTOMER_LIST']),
    downloadCmdRetailCustomer: c(['DOWNLOAD_CMD_RETAIL_CUSTOMER']),
    deleteCmdRetailCustomer: c(['DELETE_CMD_RETAIL_CUSTOMER']),
    cmdRetailCustomerHandle: c(['CMD_RETAIL_CUSTOMER_HANDLE']),
    completedCmdRetailCustomer: c(['COMPLETED_CMD_RETAIL_CUSTOMER']),
    requestCmdRetailCustomer: c(['REQUEST_CMD_RETAIL_CUSTOMER']),
    handleCmdRetailCustomer: c(['HANDLE_CMD_RETAIL_CUSTOMER']),

    getMonthlySubscribe: c(['GET_MONTHLY_SUBSCRIBE']),
    createNewFileMonthlySubscribe: c(['CREATE_NEW_FILE_MONTHLY_SUBSCRIBE']),
    updateMonthlySubscribe: c(['UPDATE_MONTHLY_SUBSCRIBE']),
    downloadMonthlySubscribe: c(['DOWNLOAD_MONTHLY_SUBSCRIBE']),

    eventPage: c(['LIST_LUCKY_CODE', 'LIST_CHECK_IN', 'LIST_EVENT_SIM']),
    //Sự kiện
    listLuckyCode: c(['LIST_LUCKY_CODE']),
    createLuckyCode: c(['CREATE_LUCKY_CODE']),
    downloadLuckyCode: c(['DOWNLOAD_LUCKY_CODE']),
    readyLuckyCode: c(['READY_LUCKY_CODE']),
    waitingLuckyCode: c(['WAITING_LUCKY_CODE']),
    luckyCodeExpire: c(['LUCKY_CODE_EXPIRE']),
    deleteLuckyCode: c(['DELETE_LUCKY_CODE']),

    // CRM-212 Quản lý SIM sự kiện
    listEventSim: c(['LIST_EVENT_SIM']),
    uploadEventSim: c(['UPLOAD_EVENT_SIM']),
    downloadEventSim: c(['DOWNLOAD_EVENT_SIM']),
    updateStatusEventSim: c(['UPDATE_STATUS_EVENT_SIM']),
    deleteEventSim: c(['DELETE_EVENT_SIM']),
    settingPlanEventSim: c(['SETTING_PLAN_EVENT_SIM']),

    //Checkin
    listCheckIn: c(['LIST_CHECK_IN']),
    finishCheckIn: c(['FINISH_CHECK_IN']),
    downloadCheckIn: c(['DOWNLOAD_CHECK_IN']),

    marketing: c(['REPORT_CAMPAIGN_OVERVIEW_PAGE', 'REPORT_OVER_TIME_PAGE']),
    reportCampaignOverviewPage: c(['REPORT_CAMPAIGN_OVERVIEW_PAGE']),
    reportOverTimePage: c(['REPORT_OVER_TIME_PAGE']),
    manageLinkedFileSftp: c([
      'MANAGE_CRONJOB',
      'MANAGE_IMPORT_FILE_SFTP',
      'MANAGE_INTEGRATION_API_KEY',
    ]),
    manageIntegrationApiKey: c(['MANAGE_INTEGRATION_API_KEY']),
    manageCronjob: c(['MANAGE_CRONJOB']),
    updateStatusJob: c(['UPDATE_STATUS_JOB']),

    manageImportFileSftp: c(['MANAGE_IMPORT_FILE_SFTP']),
    deleteJobImportFileSftp: c(['DELETE_JOB_IMPORT_FILE_SFTP']),
    importAgainImportFileSftp: c(['IMPORT_AGAIN_IMPORT_FILE_SFTP']),
    downloadImportFileSftp: c(['DOWNLOAD_IMPORT_FILE_SFTP']),

    shopPage: c(['SHOP_PRODUCT_CATEGORY', 'SHOP_PRODUCT', 'MANAGER_ORDER', 'LIST_COUPON']),

    listCustomer: c(['GET_CUSTOMER']),
    createNewFileCustomer: c(['CREATE_NEW_FILE_CUSTOMER']),
    downloadCustomer: c(['DOWNLOAD_CUSTOMER']),
    deleteCustomer: c(['DELETE_CUSTOMER']),
    menuCustomer: c(['GET_CUSTOMER', 'listRole']),
    createUpdateCustomer: c(['CREATE_EDIT_CUSTOMER']),
    updateCustomer: c(['UPDATE_CUSTOMER']),
    menuMobile: c([
      'GET_ALL_NOTIFICATION',
      'GET_ALL_REFERAL_ACTIONS',
      'GET_ALL_AUTO_NOTIFICATIONS',
    ]),
    listNotification: c(['GET_ALL_NOTIFICATION']),
    createNotification: c(['CREATE_NOTIFICATION']),
    updateNotification: c(['UPDATE_NOTIFICATION']),
    deleteNotification: c(['DELETE_NOTIFICATION']),
    updateNotificationDisplayStatus: c(['UPDATE_NOTIFICATION_DISPLAY_STATUS']),
    banCustomer: c(['BANED_CUSTOMER']),
    listReferralAction: c(['GET_ALL_REFERAL_ACTIONS']),
    downloadReferralAction: c(['DOWNLOAD_REFERAL_ACTIONS']),
    updateReferralAction: c(['UPDATE_REFERRAL_ACTION']),
    deleteReferralAction: c(['DELETE_REFERRAL_ACTION']),
    listAutoNotification: c(['GET_ALL_AUTO_NOTIFICATION']),
    updateAutoNotification: c(['UPDATE_AUTO_NOTIFICATION']),
    updateStatusAutoNotification: c(['UPDATE_STATUS_AUTO_NOTIFICATION']),
    webhookJobs: c(['WEBHOOK_JOBS']),
    //COUPON
    coupon: c(['CREATE_EDIT_COUPON']),
    listCoupon: c(['LIST_COUPON']),
    createCoupon: c(['CREATE_COUPON']),
    updateCoupon: c(['UPDATE_COUPON']),
    deleteCoupon: c(['DELETE_COUPON']),
    openCoupon: c(['OPEN_COUPON']),
    closeCoupon: c(['CLOSE_COUPON']),
    showAndHideCoupon: c(['SHOW_AND_HIDE_COUPON']),

    viewListPlan: c(['VIEW_LIST_PLAN']),
    updatePlan: c(['UPDATE_PLAN']),
    deletePlan: c(['DELETE_PLAN']),
    createPlan: c(['CREATE_PLAN']),
    viewListSubscription: c(['VIEW_LIST_SUBSCRIPTION']),
    updateSubscription: c(['UPDATE_SUBSCRIPTION']),
    deleteSubscription: c(['DELETE_SUBSCRIPTION']),
    createSubscription: c(['CREATE_SUBSCRIPTION']),
    listPayment: c(['GET_PAYMENT']),
    listAllPayment: c(['GET_ALL_PAYMENT']),
    createPayment: c(['CREATE_PAYMENT']),
    updatePayment: c(['UPDATE_PAYMENT']),
    updatePaymentStatus: c(['UPDATE_PAYMENT_STATUS']),
    confirmPayment: c(['CONFIRM_PAYMENT']),
    disablePayment: c(['DISABLE_PAYMENT']),
    deletePayment: c(['DELETE_PAYMENT']),
    downloadPayment: c(['DOWNLOAD_PAYMENT']),
    checkPayment: c(['CHECK_PAYMENT']),
    createPaymentNewFile: c(['CREATE_PAYMENT_NEW_FILE']),
    updatePaymentBillId: c(['UPDATE_PAYMENT_BILL_ID']),
    updatePaymentDate: c(['UPDATE_PAYMENT', 'UPDATE_PAYMENT_DATE']),
    showHideOrderIdPayment: c(['SHOW_HIDE_ORDERID_PAYMENT']),
    showHideOrderStatusPayment: c(['SHOW_HIDE_ORDER_STATUS_PAYMENT']),
    showHideMonthlyFeePayment: c(['SHOW_HIDE_MONTHLY_FEE_PAYMENT']),
    showHidePaymentProcessor: c(['SHOW_HIDE_PAYMENT_PROCESSOR']),
    showHidePaymentProcessDate: c(['SHOW_HIDE_PAYMENT_PROCESS_DATE']),

    listShopProduct: c(['SHOP_PRODUCT']),
    createShopProduct: c(['CREATE_SHOP_PRODUCT']),
    updateShopProduct: c(['UPDATE_SHOP_PRODUCT']),
    deleteShopProduct: c(['DELETE_SHOP_PRODUCT']),

    identityVerifiedShopProduct: c(['IDENTITY_VERIFIED_SHOP_PRODUCT']),
    putOnHomeShopProduct: c(['PUT_ON_HOME_SHOP_PRODUCT']),
    showShopProductUpdater: c(['SHOW_SHOP_PRODUCT_UPDATER']),
    identityVerifiedShopProductCategory: c(['IDENTITY_VERIFIED_SHOP_PRODUCT_CATEGORY']),

    managerOrder: c(['MANAGER_ORDER']),
    updateOrder: c(['UPDATE_ORDER']),
    // CRM-188: sửa vận đơn (UPDATE_ORDER cũng được sửa)
    updateOrderShipping: c(['UPDATE_ORDER', 'UPDATE_ORDER_SHIPPING']),
    // Permission theo từng trạng thái đơn (fallback UPDATE_ORDER_STATUS để tương thích)
    updateOrderStatusConfirm: c(['UPDATE_ORDER_STATUS_CONFIRM']),
    updateOrderStatusCancel: c(['UPDATE_ORDER_STATUS_CANCEL']),
    deleteOrder: c(['DELETE_ORDER']),
    updateOrderStatusConfimed: c(['UPDATE_ORDER_STATUS_CONFIMED']),
    updateOrderStatusDelivering: c(['UPDATE_ORDER_STATUS_DELIVERING']),
    updateOrderStatusCompleted: c(['UPDATE_ORDER_STATUS_COMPLETED']),
    updateOrderStatusConfimingPayment: c(['UPDATE_ORDER_STATUS_CONFIMING_PAYMENT']),
    updateOrderStatusUnpaid: c(['UPDATE_ORDER_STATUS_UNPAID']),

    downloadOrder: c(['DOWNLOAD_ORDER']),

    //category shop
    shopProductCategory: c(['SHOP_PRODUCT_CATEGORY']),
    createShopProductCategory: c(['CREATE_SHOP_PRODUCT_CATEGORY']),
    updateShopProductCategory: c(['UPDATE_SHOP_PRODUCT_CATEGORY']),
    deleteShopProductCategory: c(['DELETE_SHOP_PRODUCT_CATEGORY']),

    backgroundJob: c(['BACKGROUND_JOB']),
    createBackgroundJob: c(['CREATE_BACKGROUND_JOB']),
    settings: c(['SETTINGS']),

    pointSettings: c(['POINT_SETTINGS']),
    editPointSettings: c(['EDIT_POINT_SETTINGS']),
    bannerSettings: c(['BANNER_SETTINGS']),
    updateBannerSettings: c(['UPDATE_BANNER_SETTINGS']),
    expirePointSettings: c(['EXPIRE_POINT_SETTINGS']),
    updateExpirePointSettings: c(['UPDATE_EXPIRE_POINT_SETTING']),
    updatePointLimitSettings: c(['UPDATE_POINT_LIMIT_SETTINGS']),
    customerSettings: c(['CUSTOMER_SETTINGS']),
    appMaintenanceSettings: c(['APP_MAINTENANCE_SETTINGS']),
    // CRM-204: Xem Log Action theo từng màn hình
    logActionSimPostpaid: c(['LOG_ACTION_SIM_POSTPAID']),
    logActionSimPrepaid: c(['LOG_ACTION_SIM_PREPAID']),
    logActionWifi: c(['LOG_ACTION_WIFI']),
    logActionMvno: c(['LOG_ACTION_MVNO']),
    logActionActiveMvno: c(['LOG_ACTION_ACTIVE_MVNO']),
    logActionOrder: c(['LOG_ACTION_ORDER']),
    logActionPayment: c(['LOG_ACTION_PAYMENT']),
    updateAppMaintenanceSettings: c(['UPDATE_APP_MAINTENANCE_SETTINGS']),

    paymentRate: c(['PAYMENT_RATE']),
    updatePaymentRate: c(['UPDATE_PAYMENT_RATE']),
    allSettings: c(['ALL_SETTINGS']),
    settingCrm: c(['SETTING_CRM']),
    listDeadlineCancel: c(['GET_DEADLINE_CANCEL']),
    createDeadlineCancel: c(['CREATE_DEADLINE_CANCEL']),
    updateDeadlineCancel: c(['UPDATE_DEADLINE_CANCEL']),
    deleteDeadlineCancel: c(['DELETE_DEADLINE_CANCEL']),
    listTransactionType: c(['LIST_TRANSACTION_TYPE']),

    listPackageUpgradeDeadline: c(['GET_PACKAGE_UPGRADE_DEADLINE']),
    createPackageUpgradeDeadline: c(['CREATE_PACKAGE_UPGRADE_DEADLINE']),
    updatePackageUpgradeDeadline: c(['UPDATE_PACKAGE_UPGRADE_DEADLINE']),
    deletePackageUpgradeDeadline: c(['DELETE_PACKAGE_UPGRADE_DEADLINE']),

    getAllEkyc: c(['GET_ALL_EKYC']),
    updateEkyc: c(['UPDATE_EKYC']),
    downloadEkyc: c(['DOWNLOAD_EKYC']),
    createNewFileEkyc: c(['CREATE_NEW_FILE_EKYC']),
    confirmEkyc: c(['CONFIRM_EKYC']),
    deleteEkyc: c(['DELETE_EKYC']),
    showHideEkycBeforeImage: c(['SHOW_HIDE_EKYC_BEFORE_IMAGE']),
    showHideEkycAfterImage: c(['SHOW_HIDE_EKYC_AFTER_IMAGE']),
    showHideEkycLeanImage: c(['SHOW_HIDE_EKYC_LEAN_IMAGE']),
    showHideEkycPersonImage: c(['SHOW_HIDE_EKYC_PERSON_IMAGE']),

    // Biz-eKYC: bộ quyền riêng, độc lập với màn eKYC ở trên
    bizEkycGetAll: c(['BIZ_EKYC_GET_ALL']),
    bizEkycUpdate: c(['BIZ_EKYC_UPDATE']),
    bizEkycUpdateInfo: c(['BIZ_EKYC_UPDATE_INFO']),
    bizEkycDownload: c(['BIZ_EKYC_DOWNLOAD']),
    bizEkycCreateNewFile: c(['BIZ_EKYC_CREATE_NEW_FILE']),
    bizEkycConfirm: c(['BIZ_EKYC_CONFIRM']),
    bizEkycDelete: c(['BIZ_EKYC_DELETE']),
    bizEkycShowHideBeforeImage: c(['BIZ_EKYC_SHOW_HIDE_BEFORE_IMAGE']),
    bizEkycShowHideAfterImage: c(['BIZ_EKYC_SHOW_HIDE_AFTER_IMAGE']),
    bizEkycShowHideLeanImage: c(['BIZ_EKYC_SHOW_HIDE_LEAN_IMAGE']),
    bizEkycShowHidePersonImage: c(['BIZ_EKYC_SHOW_HIDE_PERSON_IMAGE']),
    bizEkycListAutoNotification: c(['BIZ_EKYC_GET_ALL_AUTO_NOTIFICATION']),
    bizEkycUpdateAutoNotification: c(['BIZ_EKYC_UPDATE_AUTO_NOTIFICATION']),
    bizEkycUpdateStatusAutoNotification: c(['BIZ_EKYC_UPDATE_STATUS_AUTO_NOTIFICATION']),

    createNewFileProduct: c([
      'CREATE_NEW_FILE_PRODUCT_SIM_PREPAID',
      'CREATE_NEW_FILE_PRODUCT_SIM_POSTPAID',
    ]),
    showHideContractAgentPrepaid: c(['SHOW_HIDE_CONTRACT_AGENT_PREPAID']),
    showHideSupplyPrepaid: c(['SHOW_HIDE_SUPPLY_PREPAID']),
    showHideCostInLabelPrepaid: c(['SHOW_HIDE_COST_IN_LABEL_PREPAID']),
    showHideCostOutLabelPrepaid: c(['SHOW_HIDE_COST_OUT_LABEL_PREPAID']),

    showHidePricingOutLabel: c(['SHOW_HIDE_PRICING_OUT_LABEL']),
    showHideCostOutLabel: c(['SHOW_HIDE_COST_OUT_LABEL']),

    showHideExportDataContractMvno: c(['SHOW_HIDE_EXPORT_DATA_CONTRACT_MVNO']),
    showHidePricingKakehodaicontractMvno: c(['SHOW_HIDE_PRICING_KAKEHODAI_CONTRACT_MVNO']),
    showHidePricingBuyMore: c(['SHOW_HIDE_PRICING_BUY_MORE']),
    userDataMvno: c(['USER_DATA_MVNO']),
    userTransferMvno: c(['USER_TRANSFER_MVNO']),
    userCmdMvno: c(['USER_CMD_MVNO']),

    showHideCmdPriceContractSim: c(['SHOW_HIDE_CMD_PRICE_CONTRACT_SIM']),

    activeWifi: c(['ACTIVE_WIFI']),
    masterDataWifi: c(['MASTER_DATA_WIFI']),
    supplierLabelWifi: c(['SUPPLIER_LABEL_WIFI']),
    costInLabelWifi: c(['COST_IN_LABEL_WIFI']),
    pricingInLabelWifi: c(['PRICING_IN_LABEL_WIFI']),
    costOutLabelWifi: c(['COST_OUT_LABEL_WIFI']),
    pricingOutLabelWifi: c(['PRICING_OUT_LABEL_WIFI']),
    detailWifi: c(['DETAIL_WIFI']),
    updateWifi: c(['UPDATE_WIFI']),
    developApi: c(['DEVELOP_API']),

    listIpWhitelist: isAdmin || c(['LIST_IP_WHITELIST']),
    createIpWhitelist: isAdmin || c(['CREATE_IP_WHITELIST']),
    updateIpWhitelist: isAdmin || c(['UPDATE_IP_WHITELIST']),
    deleteIpWhitelist: isAdmin || c(['DELETE_IP_WHITELIST']),
  };
}
